import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_004.jpg';
page.images = [
  {
    imageId: 'page004_zoom0',
    rectangle: {
      x: 730,
      y: 1103,
      width: 352,
      height: 373,
    },
    imageSrc: 'images/page004/004_komp.jpg',
  },
  {
    imageId: 'page004_zoom1',
    rectangle: {
      x: 1290,
      y: 315,
      width: 390,
      height: 763,
    },
    imageSrc: 'images/page004/004_dron.jpg',
  },
  {
    imageId: 'page004_zoom2',
    rectangle: {
      x: 1263,
      y: 1155,
      width: 200,
      height: 333,
    },
    imageSrc: 'images/page004/004_smartw.jpg',
  },
  {
    imageId: 'page004_zoom3',
    rectangle: {
      x: 421,
      y: 1187,
      width: 307,
      height: 440,
    },
    imageSrc: 'images/page004/004_tablet.jpg',
  },
  {
    imageId: 'page004_zoom4',
    rectangle: {
      x: 199,
      y: 589,
      width: 485,
      height: 428,
    },
    imageSrc: 'images/page004/004_laptop.jpg',
  },
];
page.games = [
  {
    id: 'page002_game1',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  {
    id: 'page002_game2',
    tooltip: '',
    icon: 'ikona_cw2',
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  {
    id: 'page002_game0',
    tooltip: '',
    icon: 'ikona_cw3',
    pos: {
      x: LEFT,
      y: 400,
    },
  },
  {
    id: 'page002_game4',
    tooltip: '',
    icon: 'ikona_cw4',
    pos: {
      x: LEFT,
      y: 600,
    },
  },
  {
    id: 'page002_game5',
    tooltip: '',
    icon: 'ikona_cw5',
    pos: {
      x: LEFT,
      y: 800,
    },
  },
];
// page.word = [
//   {
//     id: 'page021_game1',
//     icon: 'ikona_cw1',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     wordObj: {
//       text: 'Podpisz zdjęcia. Kliknij w ikonę programu Word.',
//       audio: 'files/page021/z21c1.mp3',
//       item: {
//         path: 'informatyka/files/page021/21_ćw_1_word.docx',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: LEFT,
//       y: 0,
//     },
//   },
//   {
//     id: 'page021_game2',
//     icon: 'ikona_cw1',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     wordObj: {
//       text: 'Przepisz podane wyrazy. Kliknij w ikonę programu Word.',
//       audio: 'files/page021/z21c2.mp3',
//       item: {
//         path: 'informatyka/files/page021/21_ćw_2_word.docx',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: LEFT,
//       y: 100,
//     },
//   },
//   {
//     id: 'page021_game3',
//     icon: 'ikona_cw1',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     wordObj: {
//       text: 'Uzupełnij zdania. Kliknij w ikonę programu Word.',
//       audio: 'files/page021/z21c3.mp3',
//       item: {
//         path: 'informatyka/files/page021/21_ćw_3_word.docx',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: LEFT,
//       y: 200,
//     },
//   },
//   {
//     id: 'page022_game2',
//     icon: 'ikona_cw1',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     wordObj: {
//       text: 'Napisz imiona dzieci w pustych ramkach. Kliknij w ikonę programu Word.',
//       audio: 'files/page022/z22c2.mp3',
//       item: {
//         path: 'informatyka/files/page022/22_ćw_2_word.docx',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: LEFT,
//       y: 300,
//     },
//   },
//   {
//     id: 'page023_game2',
//     icon: 'ikona_cw1',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     wordObj: {
//       text: 'Napisz wyrazy tematycznie związane z obrazkiem. Kliknij w ikonę programu Word.',
//       audio: 'files/page023/z23c2.mp3',
//       item: {
//         path: 'informatyka/files/page023/23_ćw_2_word.docx',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: LEFT,
//       y: 400,
//     },
//   },
//   {
//     id: 'page023_game3',
//     icon: 'ikona_cw1',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     wordObj: {
//       text: 'Uzupełnij zdania. Kliknij w ikonę programu Word.',
//       audio: 'files/page023/z23c3.mp3',
//       item: {
//         path: 'informatyka/files/page023/23_ćw_3_word.docx',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: LEFT,
//       y: 500,
//     },
//   },
//   {
//     id: 'page024_game2',
//     icon: 'ikona_cw1',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     wordObj: {
//       text: 'Uzupełnij zdania. Kliknij w ikonę programu Word.',
//       audio: 'files/page024/z24c2.mp3',
//       item: {
//         path: 'informatyka/files/page024/24_ćw_2_word.docx',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: LEFT,
//       y: 600,
//     },
//   },
//   {
//     id: 'page026_game3',
//     icon: 'ikona_cw1',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     wordObj: {
//       text: 'Uzupełnij zdania. Kliknij w ikonę programu Word.',
//       audio: 'files/page026/z26c3.mp3',
//       item: {
//         path: 'informatyka/files/page026/26_ćw_3_word.docx',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: LEFT,
//       y: 700,
//     },
//   },
// ];

export default page;
